import { getDistance } from "./getDistance";

const METRES_PER_COORDINATE_UNIT = 70;
const METRE_DISTANCE_THRESHOLD = 20;

export const isNearSculpture = (userLocation, sculptureLocation) => {
  const distance = getDistance(userLocation, sculptureLocation);
  return distance * METRES_PER_COORDINATE_UNIT < METRE_DISTANCE_THRESHOLD;
};
